<template>
    <b-modal class="contactFormModal" size="lg" @hidden="onHidden"
             :hide-footer="true" :no-close-on-backdrop="true"
             v-model="showModal" title="Contact Us">
        <customer-contact-form>

        </customer-contact-form>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import CustomerContactForm from './customerContactForm.vue'
    
    export default {
        name: "customerContactFormModal",
        data() { return { showModal: false } },
        components: { bModal, CustomerContactForm },       
        watch: {
            showContactForm: function (newValue, oldValue) {
                this.showModal = newValue;
            }
        },
        methods: {
            onHidden: function () {
                this.$store.commit("setShowCustomerContactForm", false);
            }            
        },
        computed: {
            showContactForm: function () { return this.$store.state.otherForms.showCustomerContactFormModal; },
        }
    }
</script>